const Joi = require("joi");

const kiosksSchema = (data) => {
  const schema = Joi.object({
    // Dropdown
    PodID: Joi.number()
      // .trim()
      // .pattern(new RegExp("^[a-zA-Z0-9]+$"))
      .integer()
      .invalid(0)
      .required()
      .messages({
        "any.invalid": "Please select POD.",
        "any.required": "Please select POD.",
      }),

    kioskCode: Joi.string()
      .trim()
      // .pattern(new RegExp("^[a-zA-Z0-9]+$"))
       .pattern(new RegExp("^[a-zA-Z0-9_-]+$"))
      .required()
      .messages({
        "string.pattern.base": "Please enter Kiosk Code.",
        "any.required": "Please enter Kiosk Code.",
        "string.empty": "Please enter Kiosk Code.",
      }),

    ComputerName: Joi.string()
      .trim()
      // .pattern(new RegExp("^[a-zA-Z0-9 ]+$"))
      //  .pattern(new RegExp("^[a-zA-Z0-9_-]+$"))
      .pattern(new RegExp("^[a-zA-Z0-9 _-]+$"))
      .required()
      .messages({
        "string.empty": "Please enter Computer Name.",
        "any.required": "Please enter Computer Name.",
        "string.pattern.base": "Please enter Valid Computer Name.",
      }),
    // verificationCode: Joi.string()
    //   .trim()
    //   .pattern(new RegExp("^[a-zA-Z0-9]+$"))
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Invalid verificationCode",
    //     "any.required": "The verificationCode field is required.",
    //   }),
  }).unknown(true); // This allows extra properties to exist in the object without validation.

  return schema.validate(data, {
    abortEarly: false, // This ensures that all validation errors are reported, not just the first one.
  });
};

module.exports = kiosksSchema;
